import React, { Component } from 'react';

export default class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true
    };
    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  toggle() {
    this.setState({ hidden: !this.state.hidden })
  }

  hide() {
    this.setState({hidden: true})
  }

  show() {
    this.setState({hidden: false})
  }

  render() {
    const { children, icon, iconcolor = 'fin-text-blue', position = '', btnclasses = '', btntext = '' } = this.props;
    return (
      <span className="relative">
        <button type="button" className={`btn-link text-no-decoration ${ btnclasses }`} onClick={ this.toggle } onMouseOver={ this.show } onMouseOut={ this.hide }><i className={`${ icon } ${ iconcolor }`}/>{ btntext }</button>
        <div className={`tooltip ${ position } nbn-tooltip`} role="tooltip" aria-hidden={ this.state.hidden ? 'true' : 'false' }>
          <div className="tooltip-arrow"></div>
          <div className="tooltip-inner clearfix">
            { children }
          </div>
        </div>
      </span>
    );
  }
}
